<script>
import Vue from 'vue';
import axios from 'axios';

import SkyList from 'sky-list';

import SkySearchMixin from 'sky-search/sky-search.mixin';

import { TweenLite, Cubic } from 'gsap/TweenLite';

import BoListGmapStyles from './gmap-styles';

const VueGoogleMaps = require('vue2-google-maps');

Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyA7nbroNNkkpli53_rsrOJAbRBQGeyftt4',
		libraries: 'places',
	},
});

const ls = JSON.parse(sessionStorage.getItem('bo-list'));

const preferences = {
	api: '/umbraco/api/Sorgguide/GetOffers/',
	pagination: true,
};

const preferencesMap = {
	api: '/umbraco/api/Sorgguide/GetOffersForMap/',
	pagination: true,
	limit: 9999,
};

const preferencesNation = {
	api: '/umbraco/api/Sorgguide/GetNationWideOffers',
	pagination: true,
};

const preferencesMunicipalities = {
	api: '/umbraco/api/Sorgguide/GetRegions',
};

const parameters = ls || {
	region: '',
	municipality: '',
	audiences: [],
	type: '',
};

export default {
	props: ['single'],
	mixins: [SkySearchMixin],
	components: {
		VueGoogleMaps,
	},
	data() {
		return {
			viewType: 'list', // can be list or map
			showDetailed: true,
			mapOptions: {
				settings: {
					scrollwheel: false,
					clustering: true,
					streetViewControl: false,
					mapTypeControl: false,
					styles: BoListGmapStyles,
				},
				clusterStyles: [
					{
						textColor: 'white',
						url: '/6682bo/static/maps-cluster.png',
						height: 30,
						width: 30,
					},
					{
						textColor: 'white',
						url: '/6682bo/static/maps-cluster.png',
						height: 30,
						width: 30,
					},
					{
						textColor: 'white',
						url: '/6682bo/static/maps-cluster.png',
						height: 30,
						width: 30,
					},
				],
			},
			list: new SkyList(preferences, parameters),
			listMap: new SkyList(preferencesMap, parameters),
			listNation: new SkyList(preferencesNation, parameters),
			municipalities: [],
			parameters,
			infoWindow: false,
			mapCenter: {
				lat: 56.23008005,
				lng: 11.54250005,
			},
			allAudience: {
				value: true,
			},
		};
	},
	methods: {
		setViewType(type) {
			this.viewType = type;
		},
		update() {
			if (!this.single || !this.showDetailed) {
				// Always get all results for Maps
				this.listMap.params.limit = 9999;
				this.listMap.update();

				this.list.update();

				this.listNation.update();
			}
		},
		resetSingle() {
			this.showDetailed = false;
		},
		next() {
			const viewType = this.viewType;
			if (viewType === 'list') {
				this.list.next();
			} else if (viewType === 'map') {
				this.listNation.next();
			}

			this.jumpToTopOfList();
		},
		previous() {
			const viewType = this.viewType;
			if (viewType === 'list') {
				this.list.previous();
			} else if (viewType === 'map') {
				this.listNation.previous();
			}

			this.jumpToTopOfList();
		},
		jumpToTopOfList() {
			const target = { y: window.pageYOffset };
			const to = document.querySelector('.bo-list .tabs').offsetTop;
			TweenLite.to(target, 1, {
				y: to,
				onUpdate() {
					window.scroll(0, target.y);
				},
				ease: Cubic.expoInOut,
			});
		},
		jumpToList() {
			const list = document.querySelector('.map-list');
			const scrollTo = list.getBoundingClientRect().top + window.scrollY - 30;
			const target = { y: window.scrollY };

			if (list) {
				TweenLite.to(target, 1, {
					y: scrollTo,
					onUpdate: () => {
						window.scroll(0, target.y);
					},
					ease: Cubic.easeInOut,
				});
			}
		},
		closeMarker() {
			this.infoWindow = false;
		},
		clickMarker(marker) {
			// set info window
			this.infoWindow = marker;

			// center map
			this.mapCenter = marker.location.center;
		},
		getAllMunicipalities() {
			axios
			.get(preferencesMunicipalities.api)
			.then((response) => {
				for (let i = 0; i < response.data.length; i++) {
					for (let j = 0; j < response.data[i].municipalities.length; j++) {
						this.municipalities.push(response.data[i].municipalities[j]);
					}
				}

				this.municipalities.sort((a, b) => a.name.localeCompare(b.name, 'da'));
			});
		},
	},
	created() {
		/**
		* Populate keywords from list in case it has intial value
		* (from url string for instance)
		*/
		Object.keys(this.parameters).forEach((key) => {
			if (key in this.list.params) {
				if (key === 'audiences' && location.search.indexOf('audiences') !== -1) {
					this.parameters.audiences = this.list.params.audiences.split(',');
				} else {
					this.parameters[key] = this.list.params[key];
				}
			}
		});

		Object.keys(this.parameters).forEach((key) => {
			if (key in this.listMap.params) {
				if (key === 'audiences' && location.search.indexOf('audiences') !== -1) {
					this.parameters.audiences = this.listMap.params.audiences.split(',');
				} else {
					this.parameters[key] = this.listMap.params[key];
				}
			}
		});

		Object.keys(this.parameters).forEach((key) => {
			if (key in this.listNation.params) {
				if (key === 'audiences' && location.search.indexOf('audiences') !== -1) {
					this.parameters.audiences = this.listNation.params.audiences.split(',');
				} else {
					this.parameters[key] = this.listNation.params[key];
				}
			}
		});

		/**
		*** Get all municipalities
		*** so it's possible to pick one
		*** even though no region was picked
		**/
		this.getAllMunicipalities();

		this.update();
	},
	watch: {
		parameters: {
			handler() {
				// Keep list params in sync regular Lists
				Object.keys(this.parameters).forEach((key) => {
					if (this.list.params[key] !== this.parameters[key]) {
						if (key === 'audiences') {
							this.list.params.audiences = this.parameters.audiences.join();
						} else {
							this.list.params[key] = this.parameters[key];
						}

						// Reset offset if params have changed
						this.list.params.offset = 0;
					}
				});

				Object.keys(this.parameters).forEach((key) => {
					if (this.listMap.params[key] !== this.parameters[key]) {
						if (key === 'audiences') {
							this.listMap.params.audiences = this.parameters.audiences.join();
						} else {
							this.listMap.params[key] = this.parameters[key];
						}

						// Reset offset if params have changed
						this.listMap.params.offset = 0;
					}
				});

				Object.keys(this.parameters).forEach((key) => {
					if (this.listNation.params[key] !== this.parameters[key]) {
						if (key === 'audiences') {
							this.listNation.params.audiences = this.parameters.audiences.join();
						} else {
							this.listNation.params[key] = this.parameters[key];
						}

						// Reset offset if params have changed
						this.listNation.params.offset = 0;
					}
				});

				this.update();

				sessionStorage.setItem('bo-list', JSON.stringify(this.parameters));
			},
			deep: true,
		},
		infoWindow: {
			handler() {
				if (this.infoWindow.name) {
					this.infoWindow.name =
						this.infoWindow.name.length <= 140
						? this.infoWindow.name
						: `${this.infoWindow.name.substr(140)}...`;
				}
			},
		},
		'parameters.region': {
			handler() {
				this.parameters.municipality = '';

				if (!this.parameters.region) {
					this.getAllMunicipalities();
				} else {
					axios
					.get(preferencesMunicipalities.api)
					.then((response) => {
						for (let i = 0; i < response.data.length; i++) {
							if (response.data[i].id === this.parameters.region) {
								this.municipalities = response.data[i].municipalities;
							}
						}
					});
				}
			},
		},
		'parameters.audiences': {
			handler() {
				if (this.parameters.audiences.length) {
					this.allAudience.value = false;
				} else {
					this.allAudience.value = true;
				}
			},
		},
		'allAudience.value': {
			handler() {
				if (this.allAudience.value) {
					this.parameters.audiences = [];
				}
			},
		},
	},
	computed: {
		showTotalResults() {
			if (this.list.loading) {
				return 'Henter...';
			} else if (this.viewType === 'list') {
				return `${this.list.results.pagination.total} resultater`;
			} else if (this.viewType === 'map') {
				// TODO: Fix this to not show the list totals
				// this is a backend issue with manually items not
				// having map coordinates
				return `${this.list.results.pagination.total} resultater`;
			}
			return `${this.listNation.results.pagination.total} resultater`;
		},
	},
};
</script>

<template src='./bo-list.html'></template>
<style src='./bo-list.scss'></style>



// WEBPACK FOOTER //
// bo-list.vue?17540fe1